<template>
  <div style="min-height: max-content" class="relative md:h-screen">
    <div class="flex justify-center items-center w-full h-full" v-if="loading">
      <Spin style="width: 3em; height: 3em"></Spin>
    </div>

    <div class="w-full h-full" style="" v-else>
      <div class="absolute inset-0 overflow-hidden bg-white z-0">
        <img
          class="w-full h- md:h-full object-cover opacity-70"
          :src="curDao.logo || require('@/assets/icons/nftnologo.avif')"
          alt=""
        />

        <div
          class="w-full md:h-full absolute top-0 left-0 bg-white opacity-40"
          style="height: max-content"
        ></div>

        <div
          class="
            backdrop-filter backdrop-blur-3xl
            w-full
            h-full
            absolute
            top-0
            left-0
          "
        ></div>
      </div>

      <div
        class="
          home-padding
          md:h-full
          relative
          z-10
          flex flex-col
          justify-center
        "
      >
        <div
          class="
            flex flex-col
            items-center
            md:items-start
            justify-center
            md:mr-2
            w-full
            relative
          "
        >
          <div
            class="
              font-bold
              text-xl
              md:text-2xl
              sm:text-4xl
              w-72
              md:w-full
              text-center
              mt-12.5
              md:mt-0
            "
          >
            Your Gateway to In-Depth DAO Insights
          </div>
          <div
            class="
              mt-2
              mb-4
              md:mb-2
              h-12
              w-282px
              text-body
              md:w-full
              text-center
            "
          >
            DAOBase: Where in-depth knowledge
            <span class="underline font-bold"> {{ typeText.output }}</span>
            about DAOs becomes accessible and enlightening.
          </div>
          <div
            class="
              mt-2
              md:mt-0
              mb-10
              flex
              w-full
              items-center
              justify-center
              gap-4
            "
          >
            <router-link
              to="/create"
              class="active-button"
              style="width: 117px; height: 40px"
            >
              List DAO
            </router-link>

            <router-link
              to="/creator"
              class="a-style--outline"
              style="
                width: 150px;
                height: 40px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 8px;
                border: 1px solid rgba(255, 255, 255, 0.1);
              "
            >
              Explore more
            </router-link>
          </div>
          <div
            class="
              mt-2
              md:mt-0
              mb-8
              lg:mb-6
              rounded-2xl
              border border-white-010
              flex flex-wrap
              md:flex-nowrap
            "
          >
            <div
              class="
                py-2
                lg:py-5
                flex flex-col
                justify-center
                md:items-center
                px-4
                w-40
                md:w-60
              "
            >
              <CountUp
                :value="state?.info?.daoCount"
                :is-locale="true"
                class="md:text-xl"
              />
              <div class="text-xs md:text-base text-white-070">DAOs</div>
            </div>
            <div
              class="
                py-2
                lg:py-5
                flex flex-col
                justify-center
                md:items-center
                px-4
                w-40
                md:w-60
              "
            >
              <CountUp
                :is-locale="true"
                class="md:text-xl"
                :value="state?.info?.treasury"
                :is-monetary="true"
              />
              <div class="text-white-070 text-xs md:text-base">Treasury</div>
            </div>
            <div
              class="
                py-2
                lg:py-5
                flex flex-col
                justify-center
                md:items-center
                px-4
                w-40
                md:w-60
              "
            >
              <CountUp
                :is-locale="true"
                :value="state?.info?.proposalCount"
                class="md:text-xl"
              />
              <div class="text-white-070 text-xs md:text-base">Proposals</div>
            </div>
            <div
              class="
                py-2
                lg:py-5
                flex flex-col
                justify-center
                md:items-center
                px-4
                w-40
                md:w-60
              "
            >
              <CountUp
                :is-locale="true"
                class="md:text-xl"
                :value="state?.info?.voters"
              />
              <div class="text-white-070 text-xs md:text-base">Voters</div>
            </div>
            <div
              class="
                py-2
                lg:py-5
                flex flex-col
                justify-center
                md:items-center
                px-4
                w-40
                md:w-60
              "
            >
              <CountUp
                :is-locale="true"
                class="md:text-xl"
                :value="state?.info?.chainCount"
              />
              <div class="text-white-070 text-xs md:text-base">Networks</div>
            </div>
          </div>
        </div>

        <div>
          <Swiper
            :slides-per-view="3"
            :space-between="24"
            loop
            @slideChange="onSlideChange"
            :autoplay="{ delay: 2500, disableOnInteraction: false }"
            :pagination="{ clickable: true }"
            :navigation="{ nextEl: '.custom-next', prevEl: '.custom-prev' }"
            class="mySwiper relative px-4 md:px-0 pb-8 md:pb-12.5"
            ref="swiperContainer"
            :breakpoints="{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1250: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }"
          >
            <SwiperSlide
              style="backdrop-filter: blur(50px)"
              class="
                slide
                w-75
                md:w-96
                rounded-2xl
                bg-black-80
                p-4
                md:px-6 md:py-8
                border border-white-010
                hover:border-white-040
              "
              v-for="(item, index) in state.list"
              :key="index"
            >
              <!-- Your item content here -->

              <router-link :to="`/dao/${item.daoPath}`">
                <div class="flex gap-2 md:gap-4">
                  <UiImg
                    class="
                      w-16
                      h-16
                      md:w-20 md:h-20
                      rounded-full
                      overflow-hidden
                    "
                    style="box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2)"
                    :src="item.logo || require('@/assets/icons/nftnologo.avif')"
                    alt=""
                    :key="item.id"
                  />

                  <div class="max-w-196px md:max-w-240px">
                    <div>
                      <div class="flex space-x-2 items-center">
                        <p class="font-bold line-clamp-1">
                          {{ item.name }}
                        </p>
                        <tippy
                          content="Twitter is authenticated"
                          :arrow="false"
                        >
                          <img
                            v-if="item.isTwitterOauth"
                            class="w-4 h-4 md:w-5 md:h-5"
                            src="@/assets/icons/tw_ok.avif"
                            alt=""
                          />
                        </tippy>
                      </div>
                    </div>
                    <p
                      class="text-xs mt-2 line-clamp-2"
                      style="word-break: break-all"
                    >
                      {{ item.intro }}
                    </p>
                    <div class="flex items-center mt-4 mb-2">
                      <div class="text-white-070">Treasury:</div>
                      <SecondaryTitle
                        containerStyle="flex items-center"
                        class="px-1"
                        :secondaryStat="item.rate"
                        :isSecondarySuffix="true"
                        :secondaryStateCondition="item.rate != 0"
                        :secondaryStyle="`ml-2 text-xs`"
                        :isSecondaryRate="true"
                        :isPrimaryMonetary="true"
                        :primaryStat="item.totalValueUsd"
                      />
                    </div>
                    <div class="flex justify-between">
                      <div class="flex bg-white-010 p-1 rounded-full space-x-1">
                        <UiImg
                          class="w-5 h-5 rounded-full overflow-hidden"
                          :src="chainIcon[chain]"
                          v-for="(chain, i) in item.chain"
                          :key="i"
                        ></UiImg>
                      </div>
                      <UiButton
                        style="height: 24px; width: fit-content"
                        type="outline"
                        class="rounded-lg text-xs px-2"
                        size="xs"
                      >
                        {{ item.daoType }}
                      </UiButton>
                    </div>
                  </div>
                </div>
              </router-link>
            </SwiperSlide>

            <div
              class="
                custom-next
                absolute
                z-10
                top-1/3
                md:top-auto md:bottom-0
                w-10
                h-10
                rounded-full
                bg-white-010
                flex
                justify-center
                items-center
                right-0
                cursor-pointer
              "
            >
              <span class="cursor-pointer icon iconfont icon-right"></span>
            </div>
            <div
              class="
                custom-prev
                absolute
                z-10
                top-1/3
                md:top-auto md:bottom-0
                rounded-full
                bg-white-010
                flex
                justify-center
                items-center
                left-0
                w-10
                h-10
                cursor-pointer
              "
            >
              <span class="cursor-pointer icon iconfont icon-left"></span>
            </div>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

// Install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);
import { chainIcon } from '@/constants';
import { computed, onMounted, onUnmounted, reactive, ref } from 'vue';
import UiImg from '@/components/UiImg.vue';
import UiButton from '@/components/UiButton.vue';
import RatioView from '@/components/RatioView.vue';
import { useDesktop, useReqByBool } from '@/hooks';
import { getHomeStatInfo, queryDAOPage } from '@/api/dao';
import Spin from '@/components/Spin.vue';
import EasyTyper from 'easy-typer-js';
import { formatVal, formatDate } from '@/utils';
import CountUp from '@/components/CountUp.vue';
import SecondaryTitle from '../LeaderBoard/SecondaryTitle.vue';

const swiperContainer = ref(null);
SwiperCore.use([Autoplay, Pagination, Navigation]);
function onSlideChange(swiper) {
  state.current = swiper.realIndex;
}

const intros = [
  'Overview Data',
  'Social Graph',
  'Treasury Value',
  'Governance',
];

const typeText = reactive({
  output: '',
  type: 'rollback',
  isEnd: false,
  speed: 80,
  backSpeed: 40,
  sleep: 600,
  singleBack: false,
  sentencePause: false,
});

new EasyTyper(typeText, intros, (instance) => {
  instance.input = [
    'Overview Data',
    'Treasury Balance',
    'Social Graph',
    'Governance',
    'Members',
  ];
  instance.play();
});

const items = ref([
  { content: 'Item 1' },
  { content: 'Item 2' },
  { content: 'Item 3' },
  // ... add more items as needed
]);
const isLargeScreen = useDesktop();

const state = reactive({
  list: [],
  info: {},
  current: 0,
});
const timer = ref(null);

const { loadData, loading } = useReqByBool(async () => {
  const list = await queryDAOPage(1, 11, 'home', '', 1);
  const info = await getHomeStatInfo();
  state.info = info;
  state.list = list.records;
});

const curDao = computed(() => state.list[state.current]);

onMounted(() => {
  loadData();
});

onUnmounted(() => {
  clearInterval(timer.value);
});
</script>

<style>
.custom-prev:hover,
.custom-next:hover {
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.mySwiper {
  --swiper-pagination-bullet-inactive-color: #ffffff66;
  --swiper-pagination-color: #ffffffff;
  --swiper-theme-color: #ffffffff;
  --swiper-navigation-size: 20px;
  --swiper-navigation-top-offset: 93%;
  padding-top: 4px;
}

.mySwiper .swiper-pagination {
  bottom: 11px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.mySwiper .swiper-pagination-bullet {
  width: 8px !important;
  height: 8px !important;
  margin-right: 8px;
}
.mySwiper .swiper-pagination-bullet-active {
  width: 28px !important;
  border-radius: 8px !important;
}
.slide {
  transition: all 0.3s;
}
.slide:hover {
  transform: translateY(-4px);
}
</style>
